import styled from 'styled-components';

export const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.white};
  border-radius: 8px;
  padding: 12px;
`;

export const DesktopTitle = styled.h3`
  font-weight: bold;
  font-size: 16px;
  line-height: normal;
  color: ${({ theme }) => theme.palette.BR300};
  text-transform: capitalize;
  margin-bottom: 8px;
`;

export const DesktopItems = styled.div<{
  isShowMore?: boolean;
}>`
  margin-top: 11px;
  display: flex;
  flex-direction: column;
  max-height: ${({ isShowMore }) => (isShowMore ? '400px' : '200px')};
  overflow-y: auto;
  margin-bottom: 8px;
`;

export const DesktopItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 8px;
  height: 40px;
  padding: 8px;
  & span {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: ${({ theme }) => theme.palette.black};
    opacity: 1;
  }
`;

export const ItemLabel = styled.p`
  margin: 0;
`;

export const RegionSkeletonWrapper = styled.div`
  margin-top: 20px;
`;

export const FilterRegionShowMoreBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0 20px 0;
  cursor: pointer;
`;

export const FilterRegionShowMoreTitle = styled.h3`
  font-size: 16px;
  text-transform: capitalize;
  color: ${({ theme }) => theme.palette.eclipse};
  margin-right: 10px;
`;

export const NameFilterTitle = styled.h3`
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.NL800};

  & span {
    font-weight: normal;
    margin-left: 3px;
    margin-top: 3px;
    font-size: 14px;
  }
`;

export const MobileFilterWrapper = styled.div`
  overflow-y: auto;
  max-height: 241px;
  padding: 10px 11px 10px 15px;

  & div {
    background-color: transparent;
  }
`;

export const MobileRegionFilterWrapper = styled.div`
  padding: 0 4px 10px 4px;
`;

export const ShowMoreWrapper = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: ${({ theme }) => theme.palette.B400};
  margin-left: 10px;
  cursor: pointer;
`;
